import React from "react";
import "./Timeline.css";
import { useTranslation } from 'react-i18next';

function Timeline({ experiences }) {
  const { i18n } = useTranslation();
  const lang = i18n.language; // 'fr' ou 'en'

  return (
    <div className="timeline">
      {experiences.map((exp, index) => (
        <div key={index} className="timeline-item">
          <div className="timeline-logo">
            <img src={exp.logo} alt={exp.title[lang]} />
          </div>
          <div className="timeline-content">
            <h4>{exp.date[lang]}</h4>
            <h2>{exp.title[lang]}</h2>
            {exp.description[lang] && <p>{exp.description[lang]}</p>}
            {exp.tasks && exp.tasks.length > 0 && (
              <ul>
                {exp.tasks.map((task, i) => (
                  <li key={i}>{task[lang]}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Timeline;